/* scroll-row.js — Hover-Pfeile für horizontale Scroll-Reihen
   (Place Products, Product Related, Event Other Events).
   Defensiv: läuft nur, wenn [data-scroll-wrap] existiert. */

(function () {
  var wraps = document.querySelectorAll('[data-scroll-wrap]');
  if (!wraps.length) return;

  wraps.forEach(function (wrap) {
    var row = wrap.querySelector('[data-scroll-row]');
    var prev = wrap.querySelector('[data-scroll-prev]');
    var next = wrap.querySelector('[data-scroll-next]');
    if (!row || !prev || !next) return;

    function step() {
      var item = row.querySelector('[data-scroll-item]') ||
        row.querySelector(':scope > *');
      if (item) {
        var gap = parseFloat(window.getComputedStyle(row).columnGap ||
          window.getComputedStyle(row).gap) || 14;
        return Math.max(item.getBoundingClientRect().width + gap, 200);
      }
      return Math.max(row.clientWidth * 0.8, 200);
    }

    prev.addEventListener('click', function () {
      row.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      row.scrollBy({ left: step(), behavior: 'smooth' });
    });

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      prev.disabled = row.scrollLeft <= 1;
      next.disabled = max <= 1 || row.scrollLeft >= max - 1;
    }

    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
